import { camelCase } from 'lodash';
export const parseStyleString = styleString => {
  const styleObject = {};
  styleString.split(';').forEach(style => {
    const [key, value] = style.split(/:(?!\/)/gimu);
    if (key && value) {
      const camelCaseKey = camelCase(key.trim());
      // @ts-expect-error
      styleObject[camelCaseKey] = value.trim();
    }
  });
  return styleObject;
};
//# sourceMappingURL=parse-style-string.js.map